import React from "react";
import { px2vw as p } from "../utils/cssUtil";

function ButtonInstallPWA({ onClick }) {
  return (
    <>
      <button
        onClick={() => {
          onClick();
        }}
        style={{
          position: "fixed",
          // bottom: p("164px"),
          bottom: "164px",
          right: "0",
          backgroundColor: "#FB7299",
          color: "white",
          border: "none",
          // padding: `${p("8px")} ${p("16px")}`,
          padding: `8px 16px`,
          // fontSize: p("14px"),
          fontSize: "14px",
          fontWeight: "500",
          borderTopLeftRadius: "9999px",
          borderBottomLeftRadius: "9999px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          cursor: "pointer",
          zIndex: 999,
        }}
      >
        安装到手机
      </button>
    </>
  );
}

export default ButtonInstallPWA;
